import React from 'react';

export default class TicketStubHeader extends React.Component {
  static propTypes = {
    children: React.PropTypes.node
  };

  render () {
    return (
      <div className="ticket_stub_header">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/header.js